import axios from 'axios'
import jwt from 'jsonwebtoken'
import jwt_decode from 'jwt-decode'
import { groupServicesByMenu } from '../utils/groupServicesByMenu'

const Swal = require('sweetalert2')

// A sessão é renovada (e revalidada na API) a cada 1 hora.
export const RENEW_INTERVAL_MS = 60 * 60 * 1000

let renewalInFlight = null

function clearCacheAndRedirect() {
  localStorage.clear()
  sessionStorage.clear()
  window.location.href = '/login'
}

async function logoutWithMessage() {
  await Swal(
    'Sessão encerrada',
    'Sua sessão foi encerrada. Faça login novamente.',
    'warning'
  )
  clearCacheAndRedirect()
}

function currentRadio() {
  try {
    return jwt_decode(localStorage.getItem('APP_01')).radio
  } catch (e) {
    return null
  }
}

function saveAppToken(name, payload) {
  const token = jwt.sign(payload, '12345', { expiresIn: 600 })
  localStorage.setItem(name, token)
}

// Troca a rádio atual por `radioId` espelhando o fluxo do Login.vue
// (getFirstRadio/getServicesFromRadio). Usa axios cru com o token novo para
// não passar pelo interceptor do apiSingleton.
async function switchToRadio(baseURL, token, radioId) {
  const headers = { 'x-access-token': token }
  const userId = jwt_decode(token).user[0].id
  const radios = (await axios.get(`${baseURL}users/getRadiosByUserId?userId=${userId}`, { headers })).data
  const target = radios.find(r => Number(r.id) === Number(radioId))
  if (!target) {
    throw new Error('Rádio ativa não encontrada na lista do usuário')
  }

  const radio = {
    id: target.id,
    name: target.name,
    key: target.key,
    server_key: target.server_key,
    logo: target.image_logo_url,
    cloud_name: target.cloudinary_cloud_name,
    cloud_key: target.cloudinary_api_key,
    cloud_secret: target.cloudinary_api_secret,
    master_key: target.key,
    is_parent: target.is_parent
  }

  let services = []
  if (!target.is_parent) {
    const resp = await axios.get(`${baseURL}services/getAllRadioServices/${target.id}`, { headers })
    services = resp.data.map(item => ({
      service_name: item.service_name,
      service_url: item.service_url,
      vue_icon: item.vue_icon,
      label: item.label,
      menu_group: item.menu_group,
      description: item.description,
      image: item.image,
      has_permission: item.has_permission
    }))
  }

  saveAppToken('APP_01', { radio })
  // APP_02 no formato agrupado ([{menu_label, item, subitens}]) que o blockPage()
  // das páginas lê; o formato plano do Login.vue derruba o gate de has_permission.
  saveAppToken('APP_02', { services: groupServicesByMenu(services) })
}

// Aplica a checagem de rádio após uma renovação 200.
async function applyRadioCheck(baseURL, data) {
  const activeRadioIds = (data.activeRadioIds || []).map(Number)
  if (activeRadioIds.length === 0) {
    await logoutWithMessage()
    return
  }

  const radio = currentRadio()
  if (!radio) return

  const comparedId = Number(radio.parent_id ? radio.parent_id : radio.id)
  if (activeRadioIds.includes(comparedId)) return

  try {
    await switchToRadio(baseURL, data.token, activeRadioIds[0])
  } catch (err) {
    console.error('Falha ao trocar de rádio após cancelamento', err)
    // Sem conseguir montar uma rádio coerente, a sessão não pode seguir.
    await logoutWithMessage()
    return
  }

  await Swal(
    'Atenção',
    `O acesso à rádio ${radio.parent_name || radio.name} foi encerrado. Você será redirecionado para outra rádio.`,
    'warning'
  )
  window.location.href = '/dashboard'
}

async function renew(baseURL, currentToken) {
  try {
    const response = await axios.post(`${baseURL}users/revalidateToken`, {}, {
      headers: { 'x-access-token': currentToken }
    })

    if (response.data && response.data.auth) {
      localStorage.setItem('SET_APP', response.data.token)
      await applyRadioCheck(baseURL, response.data)
    } else {
      console.error('Token revalidation failed')
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      await logoutWithMessage()
      return
    }
    // Rede, timeout, 5xx: não desloga. lastValidation não mudou, então a
    // próxima requisição tenta de novo.
    console.error('Erro ao renovar sessão (ignorado)', err)
  }
}

// Chamado pelo interceptor de request. Renova se passou 1h desde a última
// validação; renovações concorrentes compartilham a mesma Promise.
export function renewSessionIfNeeded(baseURL) {
  if (renewalInFlight) return renewalInFlight

  const currentToken = localStorage.getItem('SET_APP')
  if (!currentToken) return Promise.resolve()

  const { lastValidation } = jwt_decode(currentToken)
  if ((new Date()).getTime() - lastValidation < RENEW_INTERVAL_MS) {
    return Promise.resolve()
  }

  renewalInFlight = renew(baseURL, currentToken).finally(() => {
    renewalInFlight = null
  })
  return renewalInFlight
}
